var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfessionalDevelopmentOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512px",
    viewBox: "0 0 64 64",
    width: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Developer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.164 26.014-6.218-1.037a23.6 23.6 0 0 0 -1.757-4.238l3.665-5.128a1 1 0 0 0 -.107-1.288l-7.07-7.07a1 1 0 0 0 -1.288-.107l-5.128 3.665a23.551 23.551 0 0 0 -4.239-1.757l-1.036-6.219a1 1 0 0 0 -.986-.835h-10a1 1 0 0 0 -.986.835l-1.036 6.219a23.551 23.551 0 0 0 -4.239 1.757l-5.128-3.665a1 1 0 0 0 -1.288.107l-7.07 7.07a1 1 0 0 0 -.107 1.288l3.665 5.128a23.6 23.6 0 0 0 -1.757 4.238l-6.218 1.037a1 1 0 0 0 -.836.986v10a1 1 0 0 0 .836.986l6.218 1.037a23.6 23.6 0 0 0 1.757 4.238l-3.665 5.128a1 1 0 0 0 .107 1.288l7.07 7.07a1 1 0 0 0 1.288.107l5.128-3.665a23.551 23.551 0 0 0 4.239 1.757l1.036 6.219a1 1 0 0 0 .986.835h30a1 1 0 0 0 1-1v-8a9.01 9.01 0 0 0 -6.048-8.493 9.015 9.015 0 0 0 3.848-5.627l5.365-.894a1 1 0 0 0 .835-.986v-10a1 1 0 0 0 -.836-.986zm-24.378 23.326a18 18 0 1 1 10.159-27.34 11 11 0 0 0 -10.945 11 1 1 0 0 0 1 1h1v3a8.994 8.994 0 0 0 4.048 7.507 9.038 9.038 0 0 0 -5.262 4.833zm2.091-17.34h-.822a9 9 0 0 1 17.89 0h-.822l-7.881-1.97a.991.991 0 0 0 -.484 0zm-12.03 22a1 1 0 0 0 -.723-.8 21.509 21.509 0 0 1 -4.96-2.055 1 1 0 0 0 -1.075.056l-4.95 3.538-5.872-5.877 3.537-4.95a1 1 0 0 0 .055-1.076 21.534 21.534 0 0 1 -2.054-4.96 1 1 0 0 0 -.8-.722l-6-1v-8.307l6-1a1 1 0 0 0 .8-.722 21.534 21.534 0 0 1 2.054-4.96 1 1 0 0 0 -.055-1.076l-3.537-4.95 5.872-5.872 4.95 3.538a1 1 0 0 0 1.075.056 21.509 21.509 0 0 1 4.96-2.055 1 1 0 0 0 .723-.8l1-6h8.306l1 6a1 1 0 0 0 .723.8 21.509 21.509 0 0 1 4.96 2.055 1 1 0 0 0 1.075-.056l4.95-3.538 5.872 5.872-3.533 4.949a1 1 0 0 0 -.055 1.076 22.081 22.081 0 0 1 1.055 2.136 10.84 10.84 0 0 0 -2.741-1.017 20.01 20.01 0 1 0 -13.33 29.276 8.984 8.984 0 0 0 -.129 1.441v7h-8.153zm29.153-1v7h-18v-7a7.008 7.008 0 0 1 7-7h1v9h2v-9h1a7.008 7.008 0 0 1 7 7zm-2-16a7 7 0 0 1 -14 0v-3.219l7-1.75 7 1.75zm6-.847-4 .667v-2.82h1a1 1 0 0 0 1-1 10.916 10.916 0 0 0 -1.639-5.76l3.639.607z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.778 22.808-8.485 8.485a1 1 0 0 0 0 1.414l8.485 8.485 1.414-1.414-7.778-7.778 7.778-7.778z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.78 31h18.439v2.001h-18.439z",
    transform: "matrix(.217 -.976 .976 .217 -6.175 56.304)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 6h4v2h-4z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.322 13.322h4v2h-4z",
    transform: "matrix(.707 -.707 .707 .707 -5.932 14.322)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 30h2v4h-2z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.322 47.678h2v4h-2z",
    transform: "matrix(.707 -.707 .707 .707 -30.933 24.678)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 56h4v2h-4z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.678 12.322h2v4h-2z",
    transform: "matrix(.707 -.707 .707 .707 4.423 39.322)",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalDevelopmentOrange);
export default __webpack_public_path__ + "static/media/professionalDevelopment-orange.09b5f38a0f01de4bf6e1cff1951cc264.svg";
export { ForwardRef as ReactComponent };